import { Badge } from '@/components/ui/badge';
import { DocumentStatus, DOCUMENT_STATUS_COLORS } from '@/types/document';

interface DocumentStatusBadgeProps {
  status: DocumentStatus;
  className?: string;
}

export const DocumentStatusBadge: React.FC<DocumentStatusBadgeProps> = ({ 
  status, 
  className = '' 
}) => {
  const colorClass = DOCUMENT_STATUS_COLORS[status];
  
  return (
    <Badge 
      variant="outline" 
      className={`${colorClass} ${className}`}
    >
      {status}
    </Badge>
  );
};
